import React, { Component } from 'react'

import ReactExport from "react-data-export";


import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBDataTable, MDBTypography, MDBCard, MDBCardBody} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card, Calendar, Badge, Button  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';
import moment from 'moment'
import Getteachet2 from './Getteachet2';
import Getprograme from './Getprograme';
import Modalpayedit from './Modalpayedit';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

moment.updateLocale('en', {
  weekdaysMin : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
});



//import {ExcelFile, ExcelSheet, ExcelColumn} from "react-export-excel";
//import Loadding from './Loadding';




export default class Reporttesstotal extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          dd3:'',
          teacher:'',
          prenm:'',
          term:'',
          type:'',
          poname:'',
          typename:'ยังไม่ระบุ',
          Loadding:false,

          showtesstotal:[],
          showtesstotal1:[],
          showtesstotal5:[],
          showtesstotal2:[],
          showtesstotal3:[],

          showtesstotalnull:[],
          showtesstotalnull1:[],
          showtesstotalnull5:[],
          showtesstotalnull2:[],
          showtesstotalnull3:[],
         
        };
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getteachingschedule = this.getteachingschedule.bind(this);
        this.time = this.time.bind(this);
        this.getListData = this.getListData.bind(this);
        this.dateCellRender = this.dateCellRender.bind(this);
        this.updateSearchtype = this.updateSearchtype.bind(this);
        this.getthschedule1 = this.getthschedule1.bind(this);
        this.getshowtotalnull = this.getshowtotalnull.bind(this);
        this.exportpdf = this.exportpdf.bind(this);
      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
           setTimeout(() => {
             this.getthschedule1()
             this.getshowtotalnull()
           }, 500);
    }


    getthschedule1() {
        this.setState({ Loadding: true})
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/showtesstotal/'+this.state.term+'')
           .then(res => {
            // console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
           const stu_types = res.data.filter( ({ stu_type }) => (stu_type === "1" ));
           const stu_types5 = res.data.filter( ({ stu_type }) => (stu_type === "5" ));
           const stu_types2 = res.data.filter( ({ stu_type }) => (stu_type === "2" ));
           const stu_types3 = res.data.filter( ({ stu_type }) => (stu_type === "3" ));

           this.setState({ showtesstotal: res.data})
             this.setState({ showtesstotal1: stu_types})
             this.setState({ showtesstotal5: stu_types5})
             this.setState({ showtesstotal2: stu_types2})
             this.setState({ showtesstotal3: stu_types3})


             this.setState({ Loadding: false})
           }) 
         }, 0);
      }

      getshowtotalnull() {
        this.setState({ Loadding: true})
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/showtesstotalnull/'+this.state.term+'')
           .then(res => {
            // console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
           const stu_types1 = res.data.filter( ({ stu_type }) => (stu_type === "1" ));
           const stu_types5 = res.data.filter( ({ stu_type }) => (stu_type === "5" ));
           const stu_types2 = res.data.filter( ({ stu_type }) => (stu_type === "2" ));
           const stu_types3 = res.data.filter( ({ stu_type }) => (stu_type === "3" ));

             this.setState({ showtesstotalnull: res.data})
             this.setState({ showtesstotalnull1: stu_types1})
             this.setState({ showtesstotalnull5: stu_types5})
             this.setState({ showtesstotalnull2: stu_types2})
             this.setState({ showtesstotalnull3: stu_types3})
             this.setState({ Loadding: false})
           }) 
         }, 0);
      }


  
      
    updateSearchtype(value) {
      // console.log(event.target.value)
      // const term = event.target.value;
      const type = value;
      this.setState({ type });
        //  setTimeout(() => {
        //    this.getthschedule()
        //  }, 500);
      if (type === 1) {
        this.setState({ typename :'ภาคปกติกำแพงเพชร' });
      }
      if (type === 2) {
        this.setState({ typename :'ภาคกศ.บป.กำแพงเพชร' });
      }
      if (type === 3) {
        this.setState({ typename :'ภาคกศ.บป.กำแพงเพชร แม่สอด' });
      }
      if (type === 5) {
        this.setState({ typename :'ภาคปกติกำแพงเพชร แม่สอด' });
      }

    }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthschedulesearch/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }


      getteachingschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/showteachingschedule/'+this.state.term+'/'+this.state.idemp)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ showteachingschedule: res.data})

             if (res.data.length !== 0) {
               const teacher = res.data[0].poname;
             //  const prenm = res.data[0].prenm;
               this.setState({ teacher });
             //  this.setState({ prenm });
             }
             
           }) 
         }, 0);
      }

   

      onChange(value) {
          console.log(`selected ${value}`);
          const idemp = value;
          this.setState({ idemp });

          const teachersearcha = this.state.thschedule.filter( ({ user_teacher }) => user_teacher === idemp );
          this.setState({ poname : teachersearcha[0].poname});
          this.setState({ prenm : teachersearcha[0].prenm});


          setTimeout(() => {
            this.getteachingschedule()
          }, 500);
     }


          onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          
           getListData(value) {
             let listData;
             this.state.showteachingschedule.map((showteachingschedule) => {
             // let daysum = Number(showteachingschedule.ss)
              //  for (let  index = 0; index < 5; index++) {
              //       daysum = daysum + 7;
              //       if (value.week() === daysum) {
              //        listData = [
              //               { type: 'warning', content: 'This is warning event.' },
              //               { type: 'success', content: 'This is usual event.' },
              //             ];
              //      }
              //  }

               if (value.weekdaysMin() === "Sun") {
                listData = [
                       { type: 'warning', content: 'This is warning event.' },
                       { type: 'success', content: 'This is usual event.' },
                     ];
               }
             
              //  <>{showteachingschedule.ss}  </>  
              return listData || [];
              });


       
             return listData || [];
           }


           dateCellRender(value) {
            const listData = this.getListData(value);
            return (
              <ul className="events">
                {listData.map(item => (
                  <li key={item.content}>
                    <Badge status={item.type} text={item.content} />
                  </li>
                ))}
              </ul>
            );
           }
          
           getMonthData(value) {
            if (value.month() === 8) {
              return 1394;
            }
           }
          
           monthCellRender(value) {
            const num = this.getMonthData(value);
            return num ? (
              <div className="notes-month">
                <section>{num}</section>
                <span>Backlog number</span>
              </div>
            ) : null;
          }

          exportpdf = (id) => { //เมื่อมีการคลิกลบ ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่ง id ที่ต้องการลบไปที่ไฟล์ delete.php
             //  console.log("dfdf")
                setTimeout(() => {
                   console.log(id)
                   window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+id, '_blank');
                 
                  
                 }, 1000); 

          }




    render() {

      console.log(this.state.type)
      console.log(this.state.term)
      

        const { Option } = Select;
        const online = window.navigator.onLine;
      //  const teacher =  this.state.teachingschedule[0].map(teachingschedules => { {teachingschedule.poname} }  )     
      if (navigator.onLine) {
        console.log('online');
      } else {
        console.log('offline');
      }

      const numshowtesstotal = this.state.showtesstotal.length;
      const numshowtesstotalnull = this.state.showtesstotalnull.length;
      const totaltrue = this.state.showtesstotal.length - this.state.showtesstotalnull.length ;

      const numshowtesstotal1 = this.state.showtesstotal1.length;//ปกติกำแพงทั้งหมด
      const numshowtesstotalnull1 = this.state.showtesstotalnull1.length;//ปกติกำแพงยังไม่จัด
      const totaltrue1 = this.state.showtesstotal1.length - this.state.showtesstotalnull1.length;//ปกติกำแพงจัดแล้ว

      const numshowtesstotal5 = this.state.showtesstotal5.length;//ปกติแม่สอดทั้งหมด
      const numshowtesstotalnull5 = this.state.showtesstotalnull5.length;//ปกติแม่สอดยังไม่จัด
      const totaltrue5 = this.state.showtesstotal5.length - this.state.showtesstotalnull5.length;//ปกติแม่สอดจัดแล้ว

      const numshowtesstotal2 = this.state.showtesstotal2.length;//กศบป กำแพงทั้งหมด
      const numshowtesstotalnull2 = this.state.showtesstotalnull2.length;//กศบป กำแพงยังไม่จัด
      const totaltrue2 = this.state.showtesstotal2.length - this.state.showtesstotalnull2.length;//กศบป กำแพงจัดแล้ว

      const numshowtesstotal3 = this.state.showtesstotal3.length;//กศบป แม่สอดทั้งหมด
      const numshowtesstotalnull3 = this.state.showtesstotalnull3.length;//กศบป แม่สอดยังไม่จัด
      const totaltrue3 = this.state.showtesstotal3.length - this.state.showtesstotalnull3.length;//กศบป แม่สอดจัดแล้ว


      //ปฏิทิน

const dataSet1 = [
    {
        name: "Johson",
        amount: 30000,
        sex: 'M',
        is_married: true
    },
    {
        name: "Monika",
        amount: 355000,
        sex: 'F',
        is_married: false
    },
    {
        name: "John",
        amount: 250000,
        sex: 'M',
        is_married: false
    },
    {
        name: "Josef",
        amount: 450500,
        sex: 'M',
        is_married: true
    }
];

const dataSet2 = [
    {
        name: "Johnson",
        total: 25,
        remainig: 16
    },
    {
        name: "Josef",
        total: 25,
        remainig: 7
    }
];



      const data = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อ-นามสกุล',
            field: 'Curriculumopen_TEAM',
            sort: 'Curriculumopen_TEAM',
            width: 270
          },
        
          {
            label: 'จัดการ',
            field: 'Curriculumopen_Full_Name_EN',
            sort: 'Curriculumopen_Full_Name_EN',
            width: 100
          }


        ],

        rows: [...this.state.thschedule.map((data, i) => (
          {
             list: <>{i+1}</>,
             Curriculumopen_TEAM: <>{data.prenm}{data.poname}</>,
             Curriculumopen_Full_Name_EN: <> <MDBBtn color="unique" size="sm"  onClick={() => this.exportpdf(data.teacher_id1)}> <MDBIcon icon="print" /> พิมพ์</MDBBtn></>

          }
         ))]
        
    
    };

    const persons = <MDBDataTable
    // searching ={true}
     searchLabel="ค้นหา ชื่อ"
     striped
     bordered
     small 
     entries={20}
    // entriesOptions={["10", "20"]}
     order={["age", "desc"]}
     data={data}
     entriesLabel="จำนวนที่แสดง "
     infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
     paginationLabel={["ย้อนกลับ", "ถัดไป"]}
     responsive 
     sortRows={['random']}
     />


        return (
            <MDBContainer fluid>
              
    <Card type="inner"  title={<h4 className="unique-text"><MDBIcon icon="chart-pie" /> รายงานการจัดตารางทั้งหมด</h4>} >
    <MDBRow>
           
            <MDBCol sm="4">
              <p>เลือกภาคเรียน</p>
                <div>
                    <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกเทอม"
                            optionFilterProp="children"
                            onChange={this.updateSearchDepartment}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            value={this.state.term}
                            onSearch={this.onSearch} 
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {/* <Option value="3/2563">3/2563</Option>
                            <Option value="1/2564">1/2564</Option>
                            <Option value="2/2564">2/2564</Option>
                            <Option value="3/2564">3/2564</Option> */}
                            <Option value="1/2565">1/2565</Option>
                            <Option value="2/2565">2/2565</Option>
                            <Option value="3/2565">3/2565</Option>
                            <Option value="1/2566">1/2566</Option>
                            <Option value="2/2566">2/2566</Option>
                            <Option  value="3/2566">3/2566</Option>
                            <Option value="1/2567">1/2567</Option>
                            <Option value="2/2567">2/2567</Option>
                            <Option  value="3/2567">3/2567</Option>
                            <Option value="1/2568">1/2568</Option>
                            <Option value="2/2568">2/2568</Option>
                            <Option  value="3/2568">3/2568</Option>
                            <Option value="1/2569">1/2569</Option>
                            <Option value="2/2569">2/2569</Option>
                            <Option  value="3/2569">3/2569</Option>
                        </Select>
                    </div>
                    {/* <br/> */}

            </MDBCol>
            
            <MDBCol sm="8">
             
            </MDBCol>

  </MDBRow>

 
{/* {persons} */}
<br/>

     {this.state.Loadding === true ?<>
     <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
            </>:<>
     {this.state.showtesstotal.length !==0 ?<>
        <MDBTypography tag="h4" variant="display-4" className='text-center'>จำนวนทั้งหมด {this.state.showtesstotal.length} วิชา </MDBTypography>

        <MDBRow>
        <MDBCol md="3"></MDBCol>
        <MDBCol md="3">
                   <MDBCard color="indigo" text="white" className="text-center">
                        <MDBCardBody>
                        <MDBTypography tag="h4" variant="display-4" className='text-center text-white'>จัดแล้ว {totaltrue} วิชา </MDBTypography>
                        </MDBCardBody>
                    </MDBCard>
        </MDBCol>
        <MDBCol md="3">
                <MDBCard color="mdb-color lighten-2" text="white" className="text-center">
                    <MDBCardBody>
                    <MDBTypography tag="h4" variant="display-4" className='text-center text-white'>ยังไม่จัด {this.state.showtesstotalnull.length} วิชา </MDBTypography>
                    </MDBCardBody>
                </MDBCard>
        </MDBCol>
        <MDBCol md="3"></MDBCol>
      </MDBRow>
      <br/><br/>

      <MDBTable small>
      <MDBTableHead>
        <tr>
          <th>#</th>
          <th><h4>ประเภท</h4></th>
          <th><h4>ทั้งหมด</h4></th>
          <th><h4>จัดแล้ว</h4></th>
          <th><h4>ยังไม่จัด</h4></th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>
          <td><h4>1</h4></td>
          <td><h4>ปกติกำแพง</h4></td>
          <td> <h4 className='indigo-text'>{numshowtesstotal1}</h4></td>
          <td> <h4 className='teal-text'>{totaltrue1}</h4></td>
          <td> <h4 className='red-text'>{numshowtesstotalnull1}</h4></td>
        </tr>
        <tr>
          <td><h4>2</h4></td>
          <td><h4>ปกติแม่สอด</h4></td>
          <td><h4 className='indigo-text'>{numshowtesstotal5}</h4></td>
          <td><h4 className='teal-text'>{totaltrue5}</h4></td>
          <td><h4 className='red-text'>{numshowtesstotalnull5}</h4></td>
        </tr>
        <tr>
          <td><h4>3</h4></td>
          <td><h4>กศ.บป กำแพง</h4></td>
          <td><h4 className='indigo-text'>{numshowtesstotal2}</h4></td>
          <td><h4 className='teal-text'>{totaltrue2}</h4></td>
          <td><h4 className='red-text'>{numshowtesstotalnull2}</h4></td>
        </tr>
        <tr>
          <td><h4>4</h4></td>
          <td><h4>กศ.บป แม่สอด</h4></td>
          <td><h4 className='indigo-text'>{numshowtesstotal3}</h4></td>
          <td><h4 className='teal-text'>{totaltrue3}</h4></td>
          <td><h4 className='red-text'>{numshowtesstotalnull3}</h4></td>
        </tr>
      </MDBTableBody>
    </MDBTable>
     </>:<></>}

<p>รายวิชาที่ยังไม่ได้จัด ปกติกำแพง</p>
     <MDBTable bordered>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>เทอม</th>
                        <th>รหัสวิชา</th>
                        <th>หมู่เรียน</th>
                        <th>stu_type</th>
                        <th>อาจารย์</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                    {this.state.showtesstotalnull1.map((showtesstotalnull1,index) => {
                      return <tr>
                              <td>{index+1}</td>
                              <td>{showtesstotalnull1.id_term}</td>
                              <td>{showtesstotalnull1.id_course}</td>
                              <td>{showtesstotalnull1.id_major}</td>
                              <td>{showtesstotalnull1.stu_type}</td>
                              <td>{showtesstotalnull1.prenm}{showtesstotalnull1.poname}</td>
                              </tr>
                    })}   
                    </MDBTableBody>
                </MDBTable>


            </>}

        </Card>

            </MDBContainer>

        )
    }
}
